/**
 * keyboardActivate — G-20 helper.
 *
 * A clickable non-interactive element (`<img onClick>`, `<div onClick>`, …) is
 * invisible to keyboard and screen-reader users: it has no role, no tab stop,
 * and no Enter/Space activation. The repo's established fix (see
 * `WheelGallery/Header/GalleryHeader.jsx`, PR #2287) is to add
 * `role="button" tabIndex={0} aria-label=… onKeyDown=…`.
 *
 * This centralises the `onKeyDown` half so the same Enter/Space semantics —
 * including `preventDefault()` on Space, which otherwise scrolls the page —
 * are identical everywhere instead of being re-typed per call site.
 *
 * Usage:
 *   <img
 *     role="button"
 *     tabIndex={0}
 *     aria-label="Open preview"
 *     onClick={open}
 *     onKeyDown={onActivateKeyDown(open)}
 *   />
 *
 * For a control that is only *conditionally* actionable, pass `enabled`:
 * the handler no-ops and the caller should also set `tabIndex={-1}` +
 * `aria-disabled` so it is not a dead tab stop.
 */
export function onActivateKeyDown(handler, enabled = true) {
  return (event) => {
    if (!event) return;
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") {
      return;
    }
    event.preventDefault();
    if (!enabled || typeof handler !== "function") return;
    handler(event);
  };
}
